import { Card, CardBody } from "@dgs/core";
import styled from "styled-components";

export const StyledCard = styled(Card)`
	position: relative;
	display: flex;
	flex-direction: column;
`;

export const StyledCardBody = styled(CardBody)`
	padding: 0;
	display: flex;
	flex-direction: column;
	flex: 1;
`;
